import type { MouseEventHandler } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '../../Icon'
import { useDropdown } from '../DropdownContext'

import * as S from './styled'
import type { DropdownItemProps } from './types'

const getComponent = ({
  to,
  href,
  disabled,
}: Pick<DropdownItemProps, 'to' | 'href' | 'disabled'>) => {
  if (!disabled && to) {
    return Link
  }

  if (!disabled && href) {
    return 'a'
  }

  return 'div'
}

export const DropdownItem = ({
  active = false,
  cursor = 'pointer',
  disabled = false,
  to,
  href,
  target,
  label,
  size = 'medium',
  analytics,
  testid,
  toggleDropdownOnClick = true,
  rightIcon,
  leftIcon,
  onClick,
}: DropdownItemProps) => {
  const { toggle } = useDropdown()

  const handleClick: MouseEventHandler = (event) => {
    if (disabled) return

    onClick?.(event)

    if (toggleDropdownOnClick) toggle()
  }

  return (
    <S.Option
      as={getComponent({ to, href, disabled })}
      to={to}
      href={href}
      target={target}
      disabled={disabled}
      $active={active}
      $cursor={cursor}
      $size={size}
      data-analytics={analytics}
      data-testid={testid}
      role="menuitem"
      onClick={handleClick}
    >
      {leftIcon && (
        <S.LeftIconContainer>
          <Icon component={leftIcon} height={16} />
        </S.LeftIconContainer>
      )}
      {label}
      {rightIcon && (
        <S.RightIconContainer>
          <Icon component={rightIcon} height={16} />
        </S.RightIconContainer>
      )}
    </S.Option>
  )
}
